import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    "& .MuiTypography-body2": {
      color: theme.palette.gray.midGray,
    },
  },
}));

export default function Disclaimer() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant={"body2"} component={"h3"}>
        Os resultados aqui apresentados são baseados em uma amostra do nosso
        banco de dados, que está passando por um processo de atualização. Esta
        ferramenta não se destina a fornecer aconselhamento e não substitui um
        profissional qualificado. Para mais detalhes, consulte nossos
        especialistas.
      </Typography>
    </Box>
  );
}
